import ICONS from './icons.json';

export type IconName = keyof typeof ICONS | 'bell';

const BELL = '<svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 16V11a6 6 0 0 1 12 0v5l1.5 2h-15z"/><path d="M10 20.5a2 2 0 0 0 4 0"/></svg>';

export function svg(name: IconName): string {
  return name === 'bell' ? BELL : (ICONS as Record<string, string>)[name] ?? '';
}

// Converte o SVG do protótipo num <svg> de verdade (sem invólucro), para o CSS
// "botão > svg" continuar valendo.
const cache = new Map<string, { attrs: Record<string, string>; inner: string }>();
function parse(name: IconName) {
  let p = cache.get(name);
  if (!p) {
    const src = svg(name);
    const m = /^<svg([^>]*)>([\s\S]*)<\/svg>$/.exec(src.trim());
    const attrs: Record<string, string> = {};
    for (const [, k, v] of (m?.[1] ?? '').matchAll(/([\w:-]+)="([^"]*)"/g)) {
      const key = k!.startsWith('aria-') || k!.startsWith('data-') || k === 'viewBox' ? k! : k!.replace(/-([a-z])/g, (_, c: string) => c.toUpperCase());
      attrs[key] = v!;
    }
    attrs['aria-hidden'] = 'true';
    p = { attrs, inner: m?.[2] ?? '' };
    cache.set(name, p);
  }
  return p;
}

export function Icon({ name }: { name: IconName }) {
  const p = parse(name);
  return <svg {...p.attrs} dangerouslySetInnerHTML={{ __html: p.inner }} />;
}
